module.exports = __webpack_public_path__ + "public/img/eye.svg";